import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import login from '@/views/login.vue';
import store from '@/store';

import admin from '@/views/admin/main.vue';
import offer from '@/views/admin/offer.vue';
import gallery from '@/views/admin/gallery.vue';
// import facebook from '@/views/admin/facebook.vue';
import texts from '@/views/admin/texts.vue';
import contact from '@/views/admin/contact.vue';

import szkloGrafika from '@/views/szkloGrafika.vue';
import category from '@/views/category.vue';
import imageGallery from '@/views/imageGallery.vue';
import galleryCategory from '@/views/galleryCategory.vue'
import credits from '@/views/credits.vue';
Vue.use(VueRouter);
const router = new VueRouter({
routes:[
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/login',
    name: 'login',
    component: login,
  },
  {
    path: '/credits',
    name: 'credits',
    component: credits,
  },
  {
    path: '/category/:categoryName',
    name: 'category',
    component: category
  },
  {
    path: '/imageGallery',
    name: 'imageGallery',
    component: imageGallery
  },
  {
    path: '/gallery/:galleryCategory',
    name: 'galleryCategory',
    component: galleryCategory
  },
  {
    path: '/admin/',
    name: 'admin',
    component: admin,
    meta:{
      requriresAuth: true
    }
  },
  {
    path: '/admin/gallery',
    name: 'gallery',
    component: gallery,
    meta:{
      requriresAuth: true
    }
  },
  {
    path: '/admin/offer',
    name: 'offer',
    component: offer,
    meta:{
      requriresAuth: true
    }
  },
  {
    path: '/admin/contact',
    name: 'contact',
    component: contact,
    meta:{
      requriresAuth: true
    }
  },
  // {
  //   path: '/admin/facebook',
  //   name: 'facebook',
  //   component: facebook,
  //   meta:{
      // requriresAuth: true
  //   }
  // },
  {
    path: '/szkloGrafika',
    name: 'szklografika',
    component: szkloGrafika,
  },
  {
    path: '/admin/texts',
    name: 'text',
    component: texts,
    meta:{
      requriresAuth: true
    }
  }
]
});
router.beforeEach( async (to, from, next) => {
  store.dispatch('checkState').then(()=>{
    if(to.matched.some(record=>record.meta.requriresAuth)){
      if(store.getters.isLoggedIn !== true){
        next('/login')
      }
      else{
        next();
      }
    }
    else{
      next();
    }
  })
})

export default router
